import React from "react";
import { BodyText, ConfirmationModal } from "@knowtex-ai/components";
import sendServerLogging from "../../../utils/sendServerLogging";
import userJSON from "../../../utils/userJSON";

const DeleteCodeModal = ({ setShowDelete, codeToDelete, handleDeleteCode, status }) => {
  const handleCodeDeleteClick = async () => {
    // Call the parent's function, passing in the code to delete
    handleDeleteCode(codeToDelete);

    //server logging 
    sendServerLogging({
      body: {
        ...userJSON(localStorage.getItem("userName")),
        event: "DELETE_ICD_10_CODE",
        eventData: {
          icd_10_code: codeToDelete,
          Status: status
        },
      },
    });
  };

  const handleCancelClick = () => {
    setShowDelete(false);
  };

  return (
    <ConfirmationModal
      open
      title="Confirm Delete"
      continueText="Delete"
      cancelText="Cancel"
      continueVariant="primary-danger"
      onContinue={handleCodeDeleteClick}
      onCancel={handleCancelClick}
    >
      <BodyText>Are you sure you want to delete this code?</BodyText>
      {codeToDelete?.name ? (
        <BodyText className="mt-2 font-semibold text-ktx-red">{codeToDelete.name}</BodyText>
      ) : null}
    </ConfirmationModal>
  );
};

export default DeleteCodeModal;
